import { ButtonGroup } from './group.button';

export declare class ButtonTree extends ButtonGroup {
    static xtype: string;
    static EVENT_CHANGE: string;
}
